export default __webpack_public_path__ + "static/media/windows-main-category.d9a98e65.jpg";